import { createRouter, createWebHashHistory } from 'vue-router';
import store from '@/store/store';
// import { checkToken } from '@/token/checkToken';
// const checkToken = require('@/token/checkToken'); // 引入checkToken模块 

const routes = [
  {
    name: 'notFound',
    path: '/:path(.*)+',
    redirect: {
      name: 'Login',
    },
  },
  {
    name: 'test',
    path: '/test',
    // component:login,
    component: () => import('@/view/goods/testTest.vue'),
    meta: {
      title: '会员中心',
      requiresAuth: true
    },
  },

  {
    path: '/editorder/:id',
    name: 'editorder',
    component: () => import('@/view/goods/TestTest1.vue'),
    meta: {
      title: '修改订单',
    },
  },
  {
    path: '/errdata/:id',
    name: 'errdata',
    component: () => import('@/view/goods/TestTest1.vue'),
    meta: {
      title: '修改订单',
    },
  },
  {
    name: 'test1',
    path: '/test1',
    // component:login,
    component: () => import('@/view/goods/TestTest1.vue'),
    // component: () => import('@/view/goods/TestEmployee.vue'),
    meta: {
      title: '开单',
    },
  },
  {
    name: 'test2',
    path: '/test2',
    // component:login,
    component: () => import('@/view/goods/TestTest1.vue'),
    meta: {
      title: '测试2',
    },
  },
  {
    name: '',
    path: '/',
    component: () => import('@/view/user/UserLogin.vue'),
    meta: {
      title: '用户登陆',
    },
  },
  {
    name: 'home',
    path: '/home',
    component: () => import('@/view/HomeView.vue'),
    meta: {
      title: '主页面',
      requiresAuth: true
    },
  },
  {
    name: 'warehousebar',//仓库管理主菜单
    path: '/warehousebar',
    component: () => import('@/view/warehouse/warehouseBar.vue'),
    meta: {
      title: '库房管理',
      requiresAuth: true
    },
  },
  {
    name: 'goodsbar',//仓库管理主菜单
    path: '/goodsbar',
    component: () => import('@/view/goods/goodsBar.vue'),
    meta: {
      title: '商品管理',
      requiresAuth: true
    },
  },
  {
    name: 'goodsAdd',
    path: '/goodsadd',
    component: () => import('@/view/goods/goodsAdd.vue'),
    meta: {
      title: '添加新品',
      requiresAuth: true
    },
  },
  {
    path: '/goodsedit/:id',
    name: 'goodsedit',
    component: () => import('@/view/goods/goodsAdd.vue'),
    meta: {
      title: '修改订单',
    },
  },
  {
    name: 'wayBill',//运单登记
    path: '/wayBill',
    component: () => import('@/view/warehouse/wayBill.vue'),
    meta: {
      title: '运单登记',
      requiresAuth: true
    },
  },
  {
    name: 'inwarehouse',//运单登记
    path: '/inwarehouse',
    component: () => import('@/view/warehouse/inWarehouse.vue'),
    meta: {
      title: '入库登记',
      requiresAuth: true
    },
  },
  {
    name: 'outarehouse',//运单登记
    path: '/outwarehouse',
    component: () => import('@/view/warehouse/outWarehouse.vue'),
    meta: {
      title: '出库登记',
      requiresAuth: true
    },
  },

  {
    name: 'warehouselocation',//仓库上架位置
    path: '/warehouselocation',
    component: () => import('@/view/warehouse/warehouseLocation.vue'),
    meta: {
      title: '仓库上架',
      requiresAuth: true
    },
  },
  {
    name: 'inputwarehouse',//仓库设置
    path: '/inputwarehouse',
    component: () => import('@/view/warehouse/inputWarehouse.vue'),
    meta: {
      title: '仓库设置',
      requiresAuth: true
    },
  },
  {
    name: 'my',
    path: '/my',
    component: () => import('@/view/my/MyIs.vue'),
    meta: {
      title: '这是我的',
      requiresAuth: true
    },
  },
  {
    name: 'SubUser',
    path: '/SubUser',
    component: () => import('@/view/user/SubUser.vue'),
    meta: {
      title: '添加账号/修改密码',
      requiresAuth: true
    },
  },
  {
    name: 'goods',
    path: '/goods',
    // component: () => import('@/view/goods'),
    meta: {
      title: '商品详情',
      requiresAuth: true
    },
  },
 
];

const router = createRouter({
  routes,
  history: createWebHashHistory(),
});

router.beforeEach((to, from, next) => {
  // try {
    // const token = localStorage.getItem('token');
    // const decoded = checkToken(token, 'cysto'); // 调用checkToken函数验证token
    // console.log('decoded',decoded)
  //   // req.user = decoded; // 你可以将解码后的用户信息附加到请求对象上，以便在路由中使用
  //   next(); // 验证通过，继续处理请求
  // } catch (error) { 
  //   // 如果token验证失败，
    
  // // console.log('返回401错误') 
  //   return next('/');
  // }
  console.log(store.state.token,from)
  
  const title = to.meta && to.meta.title;
  store.commit('updateTitle', title);
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const isLoggedIn = store.state.isLoggedIn;
  // console.log(requiresAuth,isLoggedIn)

  if (requiresAuth && !isLoggedIn) {
    // 如果需要认证且用户未登录，重定向到登录页面 
    next('/');
  } else {
    // 否则，继续导航
    next();
  }
});
export { router };
// export default router ;
